export default __webpack_public_path__ + "static/media/slider.9464eafb.jpg";